<template>
  <v-col style="height: 100%;" class="d-flex flex-column justify-center align-center">
    <div class="mb-auto text-right pa-4" style="width:100%;">
      <v-spacer />
      <slot name="nav" />
    </div>
    <v-card class="pa-3 py-6" width="70%" flat>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <h2 style="color: #1B3665;">
              <slot name="title" />
            </h2>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>

    <div class="mt-auto pa-4">
      <slot name="footer" />
    </div>
  </v-col>
</template>

<script>
export default {
  name: "Column",
};
</script>
